import { createApp } from 'vue'
import App from './App.vue'
import helpBanner from './components/help_banner.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueGtag from "vue-gtag-next";
import "bootstrap"

createApp(App).component('helpBanner', helpBanner).use(store).use(router).use(VueGtag, {property : {id:'G-CR1Q821MG5'}}).mount('#app')